<template>
  <div class="page-register-success">
    <!-- 顶部 Logo + 品牌 -->
    <div class="top-header">
      <img :src="icons.appLogo" class="app-logo" alt="Kukukao" />
      <img :src="icons.logoText" class="logo-text" alt="Kukukao" />
    </div>

    <!-- 标语 + 吉祥物 同一行 -->
    <div class="slogan-row">
      <img :src="icons.slogan" class="slogan-img" alt="每天5分钟 法考学习更轻松" />
      <img :src="icons.mascot" class="mascot-img" alt="" />
    </div>

    <!-- 白色卡片：成功图标 + 文案 + 立即下载 -->
    <div class="card-wrap">
      <div class="card-inner">
        <!-- 成功图标 Group 3419.svg -->
        <div class="success-icon-wrap">
          <img :src="icons.successIcon" class="success-icon" alt="" />
        </div>
        <!-- 立即下载app 按钮 Group 1907 (1).svg -->
        <button type="button" class="btn-download-app" @click="handleOpenApp">
          <img :src="icons.btnDownload" class="btn-download-img" alt="立即下载app" />
        </button>
      </div>
    </div>

    <!-- 浏览器打开引导蒙层 -->
    <div v-if="showGuide" class="guide-mask" @click="showGuide = false">
      <div class="guide-arrow">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <path d="M30 55 C30 55 30 10 30 10" stroke="#fff" stroke-width="3" stroke-linecap="round"/>
          <path d="M18 22 L30 8 L42 22" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
      </div>
      <div class="guide-text">
        请点击右上角「 ··· 」<br/>选择「在浏览器中打开」<br/>即可下载App
      </div>
    </div>
  </div>
</template>

<script>
import appLogo from '@/assets/regiest/appLogo.svg'
import logoText from '@/assets/regiest/logo_text.svg'
import slogan from '@/assets/regiest/slogan.svg'
import mascot from '@/assets/regiest/mascot.svg'
import successIcon from '@/assets/regiest/icon_success.svg'
import btnDownload from '@/assets/regiest/btn_download_app.svg'
import { openApp } from '@/utils/openApp'

export default {
  name: 'RegisterSuccess',
  data() {
    return {
      icons: {
        appLogo,
        logoText,
        slogan,
        mascot,
        successIcon,
        btnDownload
      },
      showGuide: false
    }
  },
  methods: {
    isInAppBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      return /micromessenger|qq\/|mqqbrowser|weibo|alipay|dingtalk/.test(ua)
    },
    handleOpenApp() {
      if (this.isInAppBrowser()) {
        this.showGuide = true
      } else {
        openApp()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-register-success {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0615d 0%, #f08a87 35%, #fff5f5 70%, #ffffff 100%);
  padding: 24px 20px 40px;
  padding-top: calc(24px + env(safe-area-inset-top));
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 16px;
}

.app-logo {
  width: 40px;
  height: 40px;
  display: block;
}

.logo-text {
  height: 18px;
  width: auto;
  display: block;
}

.slogan-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -20px;
  margin-bottom: -40px;
  position: relative;
  z-index: 1;
  gap: 12px;
}

.slogan-img {
  max-width: 180px;
  width: 100%;
  height: auto;
  flex-shrink: 0;
  transform: translateY(-20px);
}

.mascot-img {
  width: 140px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.card-wrap {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 2;
}

.card-inner {
  padding: 40px 16px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.success-icon-wrap {
  margin-bottom: 16px;
}

.success-icon {
  width: 80px;
  height: auto;
  object-fit: contain;
  display: block;
}

.btn-download-app {
  width: 100%;
  max-width: 307px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: block;
  line-height: 0;
  min-height: 48px;

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
}

.btn-download-img {
  width: 100%;
  height: 48px;
  object-fit: contain;
  object-position: center;
  display: block;
  pointer-events: none;
}

.guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: calc(12px + env(safe-area-inset-top));
  padding-right: 24px;
}

.guide-arrow {
  margin-right: 16px;
}

.guide-text {
  margin-top: 12px;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.8;
  text-align: right;
}
</style>
